<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Profil bearbeiten"
    iconPath="assets/icons/identification-card.svg"
  />

  <div class="p-6">
    <form class="mb-10">
      <app-input
        type="text"
        label="Vorname"
        [control]="form.controls.firstname"
      />

      <app-input
        type="text"
        label="Nachname"
        [control]="form.controls.lastname"
      />

      <app-radio-group-with-label
        [control]="form.controls.gender"
        [options]="genderOptions"
        label="Geschlecht"
      />
    </form>

    <app-button
      text="Speichern"
      [isLoading]="isLoading()"
      [disabled]="form.invalid || !form.dirty"
      [fullWidth]="true"
      (clicked)="updateUser()"
    />
  </div>
</div>
